<template>
    <div v-loading="loading">
        <headerpage :status="type==5?2:0"></headerpage>
        <div class="deground">
        
        <div class="adaptation" style="background-color: #f6f8f7;">
            <div class="hetext" v-if="type==1||type==2">首页>政策咨询>详情</div>
            <div class="hetext" v-else-if="type==3">首页>园区通知>详情</div>
            <div class="hetext" v-else-if="type==4">首页>园区要闻>详情</div>
            <div class="hetext" v-else-if="type==5">首页>公共服务>详情</div>
            <div class="box">
                <div class="box_tt">{{detail.title}}</div>
                <div class="box_tt1"><span style="color: #9b9b9b;">发布时间：</span> {{detail.create_time}}</div>
            </div>
            <div class="box1">
                <div v-html="detail.content"></div>
                <template v-if="!detail.content">
                    <Nomore></Nomore>
                </template>
                 
            </div>
        </div>
    </div>
    </div>
     
</template>
  
<script>
import headerpage from '../../components/header/header.vue';
import Nomore from '../../components/nomore.vue';
export default {
    data() {
        return {
            type:'',//1申报，2公告,3通知，4要闻,5服务详情
            id:'',
            detail:'',
            loading:true,
        };
    },
    methods: {
        informationDetail() {
            this.loading= true
            this.$https.post(
                {
                    api: this.$api.api.index.informationDetail,
                    type: "formData",
                },
                {id:this.id},
                (response) => {
                    this.detail =  response.data
                    this.loading = false
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        noticeDetail(){
            this.loading= true
            this.$https.post(
                {
                    api: this.$api.api.index.noticeDetail,
                    type: "formData",
                },
                {id:this.id},
                (response) => {
                    this.detail =  response.data
                    this.loading = false
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        notice_detail(){
            this.loading= true
            this.$https.post(
                {
                    api: this.$api.api.demo.notice_detail,
                    type: "formData",
                },
                {id:this.id,type:this.type==3?1:2},
                (response) => {
                    this.detail =  response.data
                    this.loading = false
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        public_detail(){
            this.loading= true
            this.$https.post(
                {
                    api: this.$api.api.demo.public_detail,
                    type: "formData",
                },
                {id:this.id},
                (response) => {
                    this.detail =  response.data
                    this.loading = false
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    },
    created() {
        this.type = this.$route.query.type;
        this.id = this.$route.query.id;
        if(this.type==1){
            this.informationDetail()
        }else if(this.type==2){
            this.noticeDetail()
        }else if(this.type==3||this.type==4){
            this.notice_detail()
        }else if(this.type==5){
            this.public_detail()
        }
    },
    components: { Nomore,headerpage }
}
</script>
<style scoped>
.hetext {
    font-size: 15px;
    color: #bdbdbd;
    padding: 16px 0;
    cursor: pointer;
}
.box{
    padding: 25px 20px;
    background-color: #ffffff;
	border-radius: 10px 10px 0px 0px;
}
.box_tt{
    font-size: 20px;
    color: #171717;
    font-weight: 600;
}
.box_tt1{
    font-size: 15px;
    color: #525252;
    margin-top: 20px;
}
.box1{
    background-color: #ffffff;
	border-radius: 0px 0px 10px 10px;
    padding: 25px 20px;
    margin-top: 11px;
    margin-bottom: 20px;
    font-size: 22px;
    line-height: 36px;
    color: #737373;
}
</style>
  
  


// WEBPACK FOOTER //
// detail.vue?5e1de63b